(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.controller('EmailController', ['$scope', '$stateParams', EmailControllerFn]);

    /* controlle for email */
    function EmailControllerFn($scope, $stateParams) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            App.initAjax(); // initialize core components
        });

        activate();
         
        /* activation work */
        function activate() {
        }
    }
})();
